import { ChangeDetectorRef, Component, NgZone } from "@angular/core";
import { WaitingRoomAbstractComponent } from "../abstracts/waiting-room.abstract.component";
import { UserService } from "../../../services/user.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { PopupService } from "../../../services/popup.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { MobileDebugService } from "../../../services/mobile-debug.service";
import { HeaderService } from "../../../services/header.service";

@Component({
  selector: "app-waiting-room-desktop",
  templateUrl: "./waiting-room-desktop.component.html",
  styleUrls: ["./waiting-room-desktop.component.css"],
})
export class WaitingRoomDesktopComponent extends WaitingRoomAbstractComponent {
  isHeaderCollapsed = false;

  constructor(
    userService: UserService,
    router: Router,
    translate: TranslateService,
    cdr: ChangeDetectorRef,
    popupService: PopupService,
    deviceDetectorService: DeviceDetectorService,
    ngZone: NgZone,
    logsService: MobileDebugService,
    private headerService: HeaderService
  ) {
    super(
      userService,
      router,
      translate,
      cdr,
      popupService,
      deviceDetectorService,
      ngZone,
      logsService
    );
    this.headerService.collapsed$.subscribe((collapsed) => {
      this.isHeaderCollapsed = collapsed;
    });
  }
}
